import clsx from 'clsx';

import { CARIClassification, CredentialStatus } from '@/types';

export const zbrColor = {
  tealDeep: '#0D4F5C',
  tealMid: '#1A7A8A',
  tealCyan: '#2EC4B6',
  tealBright: '#5DDEF4',
  gold: '#C9A678',
  goldBright: '#E8C58A',
  amber: '#E8A547',
  red: '#C94646',
  redSoft: '#E66B5C',
  bgDeepest: '#0A1014',
  bgDeep: '#0F151A',
  bgCard: '#161D24',
  bgCardRaised: '#1C242C',
  bgInput: '#0F151A',
  borderSubtle: '#232C34',
  borderLine: '#2A3540',
  textBright: '#F5F1EA',
  textMid: '#B8C2C9',
  textDim: '#7F8990',
  textFaint: '#5A646B',
} as const;

export const bandColorHex: Record<CARIClassification | 'CRITICAL' | 'WITHHELD' | 'NONE', string> = {
  GREEN: zbrColor.tealCyan,
  YELLOW: zbrColor.amber,
  RED: zbrColor.redSoft,
  CRITICAL: zbrColor.red,
  WITHHELD: zbrColor.textDim,
  NONE: zbrColor.textFaint,
};

export const bandTextClass: Record<CARIClassification, string> = {
  GREEN: 'text-teal-cyan',
  YELLOW: 'text-amber',
  RED: 'text-red-soft',
};

export const bandBorderClass: Record<CARIClassification, string> = {
  GREEN: 'border-teal-cyan/20',
  YELLOW: 'border-amber/30',
  RED: 'border-red-soft/30',
};

export const bandBgClass: Record<CARIClassification, string> = {
  GREEN: 'bg-teal-cyan/10',
  YELLOW: 'bg-amber/10',
  RED: 'bg-red-soft/10',
};

export function getBandTextClass(band: CARIClassification | null | undefined): string {
  return band ? bandTextClass[band] : 'text-text-dim';
}

export function getBandBadgeClass(
  band: CARIClassification | null | undefined,
  credentialStatus?: CredentialStatus | string | null,
  muted = false
): string {
  const isMuted =
    muted ||
    !band ||
    credentialStatus === CredentialStatus.PROVISIONAL ||
    credentialStatus === CredentialStatus.WITHHELD ||
    credentialStatus === CredentialStatus.NOT_VERIFIED;

  if (isMuted) {
    return 'border-border-line bg-bg-card-raised text-text-dim';
  }

  return clsx(bandBgClass[band], bandBorderClass[band], bandTextClass[band]);
}

